export const environment = {
  enableProdMode: true,
  stage: 'Production',
  host: 'https://questionariopoa.gruposaltaedu.com/',
  hotjar: '3410610',
  analytics: 'UA-157147625-1',
  apiKey: 'cq5t9DXmpT7P1usgSDKKl1wWYE7wDgTW61XADsPU',
  api: {
    baseUrl: 'https://questionariopoa-api.gruposaltaedu.com/api',
    ApiVersion: 'v1'
  },
  paths: {
    loginPortal: 'https://atlasedu.com.br/',
    portal: 'https://atlasedu.com.br/ped'
  }
};
